import React, { useCallback } from 'react';
import { Stack } from '@fluentui/react/lib/Stack';
import { Icon, IIconStyles } from '@fluentui/react/lib/Icon';
import { Separator } from '@fluentui/react/lib/Separator';
import AdminHelpVideo from './AdminHelpVideo';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { createNewGuid } from '../../../../../components/Utils';
import { Video } from '../../../../../api/generated/data-contracts';
import { useHelpVideos } from '../useHelpVideos';
import { useSetQueryData } from '../../../../../hooks/useSetQueryData';
import { useMutation } from '@tanstack/react-query';
import { ApiCalls } from '../../../../../api/api';

function AdminVideos() {
    const { data: videos, queryKey } = useHelpVideos({ suspense: true });
    const setVideos = useSetQueryData<typeof videos>(queryKey);

    const ReorderVideo = useCallback(
        (s: Video, direction: number) => {
            setVideos(videos => {
                let neworder: number = -1;

                if (direction > 0) {
                    neworder = s.order < videos.length ? s.order + 1 : videos.length;
                } else {
                    neworder = s.order > 1 ? s.order - 1 : 1;
                }

                let orderNumber: number = 1;
                return videos
                    .map(video => {
                        if (neworder === orderNumber) {
                            orderNumber = orderNumber + 1;
                        }
                        if (video.id === s.id) {
                            return {
                                ...video,
                                order: neworder,
                            };
                        }
                        return {
                            ...video,
                            order: orderNumber++,
                        };
                    })
                    .sort((a, b) => {
                        return a.order < b.order ? -1 : 1;
                    });
            });
        },
        [setVideos],
    );
    const RemoveVideo = useCallback(
        (s: Video) => {
            setVideos(videos => videos.filter(vid => vid.id !== s.id));
        },
        [setVideos],
    );
    const VideoUpdated = useCallback(
        (id: string, header: string, description: string, url: string) => {
            setVideos(videos =>
                videos.map(video => {
                    if (video.id === id) {
                        return {
                            ...video,
                            header,
                            description,
                            url,
                        };
                    }
                    return video;
                }),
            );
        },
        [setVideos],
    );
    const { mutate } = useMutation(() => ApiCalls.setVideos(videos));
    const saveChanges = useCallback(() => {
        mutate();
    }, [mutate]);

    const AddVideoClick = useCallback(() => {
        setVideos(videos => [...videos, { id: createNewGuid(), header: 'New Video', description: '', source: '', url: '', order: videos.length + 1 }]);
    }, [setVideos]);

    return (
        <div style={outerDivStyle}>
            <h3>Videos</h3>
            <Separator>
                <Icon iconName="ProjectCollection" styles={separatorIconStyles} />
            </Separator>
            <br />
            <div style={{ display: 'inline-block' }}>
                <Stack tokens={{ childrenGap: 10 }}>
                    {videos.map(video => {
                        return (
                            <AdminHelpVideo key={video.id} ReorderVideo={ReorderVideo} RemoveVideo={RemoveVideo} VideoUpdated={VideoUpdated} Video={video} />
                        );
                    })}
                    <Separator>
                        <Stack tokens={{ childrenGap: 10 }}>
                            <Stack.Item align="center">
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <DefaultButton text="Add Video" onClick={AddVideoClick}></DefaultButton>
                                    <PrimaryButton onClick={saveChanges} text="Save Videos" />
                                </Stack>
                            </Stack.Item>
                        </Stack>
                    </Separator>
                </Stack>
                <br />
                <br />
                <br />
            </div>
        </div>
    );
}

export default AdminVideos;

const outerDivStyle = {
    margin: '20px 0px 0px 0px',
    display: 'block',
    justifyContent: 'center',
    textAlign: 'center',
    // backgroundColor: 'white',
} as React.CSSProperties;

const separatorIconStyles: IIconStyles = {
    root: {
        fontSize: '24px',
        height: '24px',
        width: '24px',
    },
};
